import React from "react";
import { motion } from "framer-motion";

// Elegant scroll-reveal wrapper: soft fade + subtle rise.
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal for headlines.
export const MaskLines = ({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0, testid }) => {
  return (
    <div className={className} data-testid={testid}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            className={lineClassName}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
};
